// Actions

export const FETCH_REVIEWS = 'go4ellis/Review/FETCH_REVIEWS';
export const FETCH_REVIEWS_SUCCESS = 'go4ellis/Review/FETCH_REVIEWS_SUCCESS';
export const FETCH_REVIEWS_ERROR = 'go4ellis/Review/FETCH_REVIEWS_ERROR';

export const EVALUATE_REVIEW = 'go4ellis/Review/EVALUATE_REVIEW';
export const EVALUATE_REVIEW_SUCCESS = 'go4ellis/Review/EVALUATE_REVIEW_SUCCESS';
export const EVALUATE_REVIEW_ERROR = 'go4ellis/Review/EVALUATE_REVIEW_ERROR';